import TablaConciliacion from "../../../TablaConciliacion";

function TablaIccu() {
  return <TablaConciliacion nombreUseCase="ICCU" titulo="ICCU" />;
}

export default TablaIccu;
